export default "__VITE_ASSET__FVF5vaMb__"